import { createSlice } from "@reduxjs/toolkit";

export const loginSlice = createSlice({
  name: "user",
  initialState: {
    value: false,
    role: "",
    isHybridConsultant: false,
    permissions: {},
    details: {},
  },
  reducers: {
    setLogin: (state, action) => {
      state.value = action.payload?.role ? true : false;
      state.role = action.payload?.role ?? "";
      state.isHybridConsultant = action.payload.isHybridConsultant ? true : false;
      state.permissions = action.payload.permissions ?? {};
      state.details.userId = action.payload?.userId;
    },
    setLogout: (state) => {
      state.role = "";
      state.value = false;
    },
    setUser: (state, action) => {
      state.details = { ...state.details, ...action.payload };
    },
  },
});

export const { setLogin, setLogout, setUser } = loginSlice.actions;

export default loginSlice.reducer;
